module.exports = __webpack_public_path__ + "img/okg-logo.ac229959.png";